import React, {Fragment, useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router";
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import {PaginationFillTable, TableLoader} from "components";
import {SearchAndFilerFull} from "./searchAndFilerFull";
import {NotYet} from "./notYet";
import {FindLoad, getSkipCount, limit, SendPageSave} from "utils";

export const FullTable = ({
                              classNameWrapper,
                              head,
                              body,
                              list,
                              loadingType,
                              loading,
                              handleClick,
                              listCount,
                              generateTable,
                              getParams,
                              currentParams,
                              containerStyles = {},
                              getCellForStyle = () => {
                                  return {}
                              },
                              getRowForStyle = () => {
                                  return {}
                              },
                              emptyState
                          }) => {
    const [listInfo, setListInfo] = useState(list);
    const [searched, setSearched] = useState({name: "", value: ""});
    const [page, setPage] = useState(1);
    const navigate = useNavigate();
    const loader = FindLoad(loadingType ? loadingType : "");
    const location = useLocation();
    const info = location?.state;

    useEffect(() => {
        if (list && !searched?.value) {
            setListInfo(list);
        }
    }, [list]);


    useEffect(() => {
        if (info?.page && !getParams) {
            setPage(info?.page);
        }
    }, [info]);

    useEffect(() => {
        if (currentParams?.page) {
            setPage(currentParams?.page);
        }
    }, [currentParams])


    const changePage = (number) => {
        setPage(number);
        setSearched({name: "", value: ""});

        if (getParams) {
            const _skip = getSkipCount(number, limit);
            const pushInfo = {...info};
            pushInfo.page = number;
            pushInfo.skip = _skip;
            getParams(pushInfo);
        } else {
            SendPageSave(navigate, number, info);
        }
    };

    const renderItems = (i, item, index) => {
        if (item) {
            if (item?.button) {
                return item?.button((name) => handleClick(i, name), i);
            } else {
                return item?.rowText(i, index);
            }
        }
    };

    const handleClickRow = (item, i) => {
        if (item?.notClickable !== true && handleClick) {
            handleClick(i);
        }
    };

    const classesWrapper = ["full-table-styles"];
    if (classNameWrapper) classesWrapper.push(classNameWrapper);


    return (
        <div className={classesWrapper.join(" ")}>
            <div className="table-wrapper-desktop">
                <TableContainer
                    className="table-container"
                    component={Paper}
                    style={containerStyles}
                >
                    <Table
                        stickyHeader
                        className="table"
                        size="small"
                        aria-label="a dense table"
                    >
                        <TableHead className="table-head">
                            <TableRow>
                                {head &&
                                    head.map((i, j) =>
                                        i ? (
                                            <TableCell
                                                key={j}
                                                style={{
                                                    width: i.width || '',
                                                    minWidth: i.minWidth || '',
                                                }}
                                            >
                                                {i?.renderView ? (
                                                    <div>{i?.renderView}</div>
                                                ) : (
                                                    <SearchAndFilerFull
                                                        setListInfo={setListInfo}
                                                        list={list}
                                                        item={i}
                                                        page={page}
                                                        searched={searched}
                                                        setSearched={setSearched}
                                                        generateTable={generateTable}
                                                    />
                                                )}
                                            </TableCell>
                                        ) : null
                                    )}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {loader?.length || !!loading ? (
                                <TableLoader styles={containerStyles}/>
                            ) : !listInfo?.length ? (
                                    <NotYet buttonText={emptyState?.emptyBtnText}
                                            EmptySvg={emptyState?.EmptySvg}
                                            clickToAddButton={emptyState?.clickToEmptyAddButton}
                                            notTitleText={emptyState?.notTitleText}
                                            notDescText={emptyState?.notDescText}
                                            styles={containerStyles}
                                    />
                                )
                                :
                                listInfo?.map(
                                    (i, j) =>
                                        i && (
                                            <Fragment key={j}>
                                                <TableRow
                                                    style={handleClick ? {cursor: "pointer"} : {}}
                                                    className="table-row"
                                                >
                                                    {body?.map((item, ke) => {
                                                        if (item) {
                                                            return (
                                                                <Fragment key={ke}>
                                                                    <TableCell
                                                                        sx={
                                                                            item?.width
                                                                                ? {
                                                                                    width: item.width,
                                                                                    maxWidth: item?.width,
                                                                                    backgroundColor: getCellForStyle?.(item)?.backgroundColor,
                                                                                }
                                                                                : {}
                                                                        }
                                                                        className=""
                                                                        onClick={() => handleClickRow(item, i)}
                                                                    >
                                                                        {renderItems(i, item) || "---"}
                                                                    </TableCell>
                                                                </Fragment>
                                                            );
                                                        }
                                                    })}
                                                </TableRow>
                                            </Fragment>
                                        )
                                )
                            }
                        </TableBody>
                    </Table>
                </TableContainer>


                {listCount > 0 && (
                    <div style={{height: "76px"}}>
                        <PaginationFillTable
                            listLength={listInfo?.length}
                            page={page}
                            handleReturn={(number) => changePage(number)}
                            count={listCount}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};
